import * as React from "react";
import { memo } from "react";
import styled, { ThemeContext } from "styled-components";
import { themeGet } from "@styled-system/theme-get";
import { Text } from "pcln-design-system";
const IconWrapper = /*#__PURE__*/styled(Text).withConfig({
  displayName: "PackagesFillGreenOnBlue__IconWrapper",
  componentId: "sc-bd3hjd-0"
})(["display:inline-block;"]);
function BaseComponent({
  title,
  titleId,
  ...props
}) {
  const themeContext = React.useContext(ThemeContext);
  const themeProps = {
    theme: themeContext
  };
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 44 44",
    focusable: false,
    "aria-hidden": true,
    role: "img",
    "aria-labelledby": titleId,
    ...props
  }, title ? React.createElement("title", {
    id: titleId
  }, title) : null, React.createElement("g", {
    filter: "url(#PackagesFillGreenOnBlue_tsx__a)"
  }, React.createElement("mask", {
    id: "PackagesFillGreenOnBlue_tsx__b",
    width: 36,
    height: 36,
    x: 3.75,
    y: 1.583,
    fill: "#000",
    maskUnits: "userSpaceOnUse"
  }, React.createElement("path", {
    fill: themeGet("palette.background.lightest")(themeProps),
    d: "M3.75 1.583h36v36h-36z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    d: "M21.375 2.583a.792.792 0 0 1 .142 1.57l-.142.014h-.792V10.5h1.584a4.75 4.75 0 0 1 4.742 4.47l.007.257V7.333h-.79a.792.792 0 0 1-.143-1.57l.143-.013h9.5a.792.792 0 0 1 .142 1.57l-.142.013h-.793v9.5a4.75 4.75 0 0 1 4.742 4.471l.008.28v9.5a4.75 4.75 0 0 1-4.47 4.741l-.279.008c0 .875-.532 1.584-1.187 1.584-.656 0-1.188-.71-1.188-1.584h-3.168c0 .875-.532 1.584-1.187 1.584-.656 0-1.188-.71-1.188-1.584a4.73 4.73 0 0 1-2.375-.636 4.7 4.7 0 0 1-2.007.622l-.367.014c0 .897-.71 1.623-1.584 1.623S19 36.73 19 35.833h-6.333a1.583 1.583 0 1 1-3.167 0 4.75 4.75 0 0 1-4.742-4.47l-.008-.28V15.25a4.75 4.75 0 0 1 4.47-4.742l.28-.008h1.584V4.167h-.792a.792.792 0 0 1-.143-1.57l.143-.014h11.083M12.667 10.5H19V4.167h-6.333zm20.583 6.333v-9.5H28.5v9.5z",
    clipRule: "evenodd"
  })), React.createElement("path", {
    fill: themeGet("palette.text.heading")(themeProps),
    fillRule: "evenodd",
    d: "M21.375 2.583a.792.792 0 0 1 .142 1.57l-.142.014h-.792V10.5h1.584a4.75 4.75 0 0 1 4.742 4.47l.007.257V7.333h-.79a.792.792 0 0 1-.143-1.57l.143-.013h9.5a.792.792 0 0 1 .142 1.57l-.142.013h-.793v9.5a4.75 4.75 0 0 1 4.742 4.471l.008.28v9.5a4.75 4.75 0 0 1-4.47 4.741l-.279.008c0 .875-.532 1.584-1.187 1.584-.656 0-1.188-.71-1.188-1.584h-3.168c0 .875-.532 1.584-1.187 1.584-.656 0-1.188-.71-1.188-1.584a4.73 4.73 0 0 1-2.375-.636 4.7 4.7 0 0 1-2.007.622l-.367.014c0 .897-.71 1.623-1.584 1.623S19 36.73 19 35.833h-6.333a1.583 1.583 0 1 1-3.167 0 4.75 4.75 0 0 1-4.742-4.47l-.008-.28V15.25a4.75 4.75 0 0 1 4.47-4.742l.28-.008h1.584V4.167h-.792a.792.792 0 0 1-.143-1.57l.143-.014h11.083M12.667 10.5H19V4.167h-6.333zm20.583 6.333v-9.5H28.5v9.5z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    fill: themeGet("palette.text.heading")(themeProps),
    d: "m21.517 4.154.01.1.008-.002zm-.142.013v.1h.009zm-.792 0v-.1h-.1v.1zm0 6.333h-.1v.1h.1zm6.326 4.47.1-.002v-.003zm.007.257-.1.003.2-.003zm0-7.894h.1v-.1h-.1zm-.933-1.57-.009-.1-.009.001zm.143-.013v-.1h-.01zm7.91 0v.1zm.006 0v-.1zm.005 0v.1zm1.721 1.57.009.1.009-.001zm-.142.013v.1h.009zm-.793 0v-.1h-.1v.1zm0 9.5h-.1v.1h.1zm4.742 4.471.1-.003v-.003zm.008.28h.1v-.004zm-4.47 14.241.002.1h.003zm-.279.008-.003-.1-.097.003v.097zm-2.375 0h.1v-.1h-.1zm-3.168 0v-.1h-.1v.1zm-2.375 0v-.1h-.1v.1zm-2.375-.636.05-.086-.05-.03-.05.03zm-2.007.622.004.1h.003zm-.367.014-.004-.1-.096.004v.096zm-3.167 0h.1v-.1H19zm-6.333 0v-.1h-.1v.1zm-3.167 0h.1v-.1h-.1zm-4.742-4.47-.1.002v.003zm-.008-.28h-.1v.003zm4.47-20.575-.002-.1h-.003zm.28-.008v-.1h-.003zm1.584 0v.1h.1v-.1zm0-6.333h.1v-.1h-.1zm-.935-1.57-.009-.1h-.008zm.143-.014v-.1h-.01zm2.375 7.917h-.1v.1h.1zm6.333 0v.1h.1v-.1zm0-6.333h.1v-.1H19zm-6.333 0v-.1h-.1v.1zM33.25 16.833v.1h.1v-.1zm0-9.5h.1v-.1h-.1zm-4.75 0v-.1h-.1v.1zm0 9.5h-.1v.1h.1zM22.266 3.375c0-.492-.4-.892-.892-.892v.2c.382 0 .692.31.692.692zm-.732.877a.89.89 0 0 0 .732-.877h-.2c0 .34-.245.622-.568.68zm-.151.014.142-.013-.018-.199-.142.013zm-.8 0h.791v-.2h-.792zm.1 6.234V4.167h-.2V10.5zm-.1.1h1.583v-.2h-1.584zm1.583 0a4.65 4.65 0 0 1 4.642 4.377l.2-.012a4.85 4.85 0 0 0-4.842-4.565zm4.642 4.374.007.256.2-.005-.007-.257zm.207.253V7.333h-.2v7.894zm-.1-7.994h-.79v.2h.79zm-.79 0a.69.69 0 0 1-.692-.691h-.2c0 .492.4.891.892.891zm-.692-.691c0-.34.245-.622.567-.68l-.036-.198a.89.89 0 0 0-.731.878zm.558-.68.143-.012-.018-.2-.143.013zm.134-.012h1.582v-.2h-1.582zm1.582 0h6.328v-.2h-6.328zm6.328 0h.006v-.2h-.006zm.005 0h.006v-.2h-.005zm.006 0h1.579v-.2h-1.579zm1.579 0c.382 0 .691.31.691.692h.2c0-.493-.399-.892-.891-.892zm.691.692c0 .34-.244.622-.567.68l.036.197a.89.89 0 0 0 .731-.877zm-.558.679-.142.013.018.199.142-.013zm-.133.012h-.793v.2h.793zm-.893.1v9.5h.2v-9.5zm.1 9.6a4.65 4.65 0 0 1 4.642 4.377l.2-.012a4.85 4.85 0 0 0-4.842-4.565zm4.642 4.374.008.28.2-.007-.008-.279zm.008.276v9.5h.2v-9.5zm0 9.5a4.65 4.65 0 0 1-4.376 4.642l.011.2a4.85 4.85 0 0 0 4.565-4.842zm-4.373 4.642-.279.008.006.2.278-.008zm-1.463 1.792c.366 0 .69-.199.92-.504.228-.305.367-.723.367-1.18h-.2c0 .418-.127.792-.328 1.06-.2.267-.47.424-.76.424zm-1.288-1.684c0 .457.139.875.368 1.18s.553.504.92.504v-.2c-.29 0-.56-.157-.76-.424a1.78 1.78 0 0 1-.328-1.06zm.1-.1h-3.168v.2h3.168zm-3.268.1c0 .418-.127.792-.328 1.06-.2.267-.47.424-.76.424v.2c.367 0 .691-.199.92-.504s.368-.723.368-1.18zm-1.087 1.484c-.29 0-.56-.157-.76-.424a1.78 1.78 0 0 1-.328-1.06h-.2c0 .457.139.875.368 1.18s.553.504.92.504zm-1.188-1.384v-.2zm0-.2a4.63 4.63 0 0 1-2.325-.622l-.1.173c.713.413 1.542.65 2.426.65zm-2.426-.622a4.6 4.6 0 0 1-1.964.609l.015.199a4.8 4.8 0 0 0 2.05-.635zm-1.96.608-.367.014.008.2.367-.014zm-1.947 1.837c.932 0 1.684-.773 1.684-1.723h-.2c0 .844-.667 1.523-1.484 1.523zM18.9 35.833c0 .95.751 1.723 1.683 1.723v-.2c-.817 0-1.483-.68-1.483-1.523zm.1-.1h-6.333v.2H19zm-6.433.1c0 .82-.664 1.484-1.484 1.484v.2c.93 0 1.684-.754 1.684-1.684zm-1.484 1.484c-.819 0-1.483-.664-1.483-1.484h-.2c0 .93.754 1.684 1.683 1.684zM9.5 35.733a4.65 4.65 0 0 1-4.642-4.376l-.2.011A4.85 4.85 0 0 0 9.5 35.933zM4.858 31.36l-.008-.28-.2.006.008.28zm-.008-.277V15.25h-.2v15.833zm0-15.833a4.65 4.65 0 0 1 4.377-4.642l-.012-.2A4.85 4.85 0 0 0 4.65 15.25zm4.374-4.642.279-.008-.006-.2-.279.008zM9.5 10.6h1.584v-.2H9.5zm1.484-6.433V10.5h.2V4.167zm-.692.1h.792v-.2h-.792zM9.4 3.375c0 .492.4.892.892.892v-.2a.69.69 0 0 1-.692-.692zm.732-.877a.89.89 0 0 0-.732.877h.2c0-.34.245-.622.567-.68zm.15-.014-.142.012.018.2.143-.013zm1.594 0h-1.584v.2h1.584zm7.916 0h-7.916v.2h7.916zm1.583 0h-1.583v.2h1.583zM12.667 10.6H19v-.2h-6.333zM18.9 4.167V10.5h.2V4.167zm-6.233.1H19v-.2h-6.333zm.1 6.233V4.167h-.2V10.5zm20.583 6.333v-9.5h-.2v9.5zm-.1-9.6H28.5v.2h4.75zm-4.85.1v9.5h.2v-9.5zm.1 9.6h4.75v-.2H28.5z",
    mask: "url(#PackagesFillGreenOnBlue_tsx__b)"
  }), React.createElement("path", {
    fill: themeGet("palette.highlight.light")(themeProps),
    fillRule: "evenodd",
    d: "M26.917 18.417h7.916A3.167 3.167 0 0 1 38 21.583v9.5l-.009.237a3.167 3.167 0 0 1-3.158 2.93h-7.916l-.275-.012a3 3 0 0 1-.78-.17 4.73 4.73 0 0 0 1.055-2.985zm3.166 2.375c.388 0 .712.28.779.65l.012.141v9.5a.792.792 0 0 1-1.57.143l-.013-.143v-9.5c0-.437.354-.791.792-.791m3.959 0c.388 0 .712.28.779.65l.012.141v9.5a.792.792 0 0 1-1.57.143l-.013-.143v-9.5c0-.437.354-.791.792-.791",
    clipRule: "evenodd"
  }), React.createElement("path", {
    fill: themeGet("palette.pricePrimary.dark")(themeProps),
    fillRule: "evenodd",
    d: "M30.862 21.441a.792.792 0 0 0-1.571.142v9.5l.013.143a.792.792 0 0 0 1.57-.143v-9.5zm3.959 0a.792.792 0 0 0-1.571.142v9.5l.013.143a.792.792 0 0 0 1.57-.143v-9.5z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    fill: themeGet("palette.primary.base")(themeProps),
    fillRule: "evenodd",
    d: "M22.165 12.083a3.167 3.167 0 0 1 3.167 3.167v15.833a3.167 3.167 0 0 1-3.167 3.167H9.5a3.167 3.167 0 0 1-3.167-3.167V15.25a3.167 3.167 0 0 1 3.167-3.167zM10.29 15.25a.79.79 0 0 0-.78.65l-.012.142v15.041l.013.143a.792.792 0 0 0 1.558 0l.012-.143V16.042l-.012-.143a.79.79 0 0 0-.78-.649m5.543 0a.79.79 0 0 0-.78.65l-.012.142v15.041l.013.143a.792.792 0 0 0 1.558 0l.012-.143V16.042l-.012-.143a.79.79 0 0 0-.78-.649m5.54 0a.79.79 0 0 0-.778.65l-.013.142v15.041l.013.143a.792.792 0 0 0 1.558 0l.012-.143V16.042l-.012-.143a.79.79 0 0 0-.78-.649",
    clipRule: "evenodd"
  }), React.createElement("path", {
    fill: themeGet("palette.primary.tint")(themeProps),
    fillRule: "evenodd",
    d: "M10.29 15.25a.79.79 0 0 0-.78.65l-.012.142v15.041l.013.143a.792.792 0 0 0 1.558 0l.012-.143V16.042l-.012-.143a.79.79 0 0 0-.78-.649m5.543 0a.79.79 0 0 0-.78.65l-.012.142v15.041l.013.143a.792.792 0 0 0 1.558 0l.012-.143V16.042l-.012-.143a.79.79 0 0 0-.78-.649m4.762.65a.792.792 0 0 1 1.558 0l.012.142v15.041l-.012.143a.792.792 0 0 1-1.558 0l-.013-.143V16.042z",
    clipRule: "evenodd"
  })), React.createElement("defs", null, React.createElement("filter", {
    id: "PackagesFillGreenOnBlue_tsx__a",
    width: 48,
    height: 48,
    x: -2.25,
    y: -2,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), React.createElement("feOffset", {
    dy: 2
  }), React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.407843 0 0 0 0 0.937255 0 0 0 0.12 0"
  }), React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_258_5681"
  }), React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), React.createElement("feOffset", {
    dy: 1
  }), React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.407843 0 0 0 0 0.937255 0 0 0 0.16 0"
  }), React.createElement("feBlend", {
    in2: "effect1_dropShadow_258_5681",
    result: "effect2_dropShadow_258_5681"
  }), React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), React.createElement("feOffset", null), React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.407843 0 0 0 0 0.937255 0 0 0 0.24 0"
  }), React.createElement("feBlend", {
    in2: "effect2_dropShadow_258_5681",
    result: "effect3_dropShadow_258_5681"
  }), React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), React.createElement("feOffset", {
    dy: -1
  }), React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.407843 0 0 0 0 0.937255 0 0 0 0.03 0"
  }), React.createElement("feBlend", {
    in2: "effect3_dropShadow_258_5681",
    result: "effect4_dropShadow_258_5681"
  }), React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect4_dropShadow_258_5681",
    result: "shape"
  }))));
}
const PackagesFillGreenOnBlue = props => React.createElement(IconWrapper, {
  fontSize: props.size,
  lineHeight: props.size,
  verticalAlign: "middle",
  className: props.className
}, React.createElement(BaseComponent, null));
/** @public */
const Memo = memo(PackagesFillGreenOnBlue);
export default Memo;